import { Link } from 'react-router-dom';
import { C, wrap, SectionLabel } from '../styles';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import CTASection from '../content/CTASection';
import { useDocumentMeta } from './useDocumentMeta';

export { P, H2b, H3b, UL, LI } from '../content/Typography';

export default function BlogLayout({ title, description, children, label = 'Guide' }) {
  useDocumentMeta(`${title} | MetalMatch`, description);

  return (
    <>
      <Nav />

      <section style={{ padding: '64px 0 20px', borderBottom: `1px solid ${C.bdr}` }}>
        <div style={wrap}>
          <Link to="/blog" style={{ fontSize: 12, fontWeight: 600, color: C.navy, letterSpacing: '0.02em', display: 'inline-block', marginBottom: 22 }}>
            ← All guides
          </Link>
          <SectionLabel>{label}</SectionLabel>
          <h1 style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: 'clamp(30px, 5vw, 48px)',
            fontWeight: 700, lineHeight: 1.08,
            textTransform: 'uppercase', color: C.txt,
            maxWidth: 780, marginBottom: 16,
          }}>{title}</h1>
          <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.7, maxWidth: 640 }}>{description}</p>
        </div>
      </section>

      <section style={{ padding: '48px 0 8px' }}>
        <div style={{ ...wrap, maxWidth: 760 }}>
          {children}
        </div>
      </section>

      <CTASection />

      <Footer />
    </>
  );
}
